import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCookies from "vue-cookies";
// import { ObserveVisibility } from "vue-observe-visibility";
import VueCarousel from "vue-carousel";
// import VueDragscroll from "vue-dragscroll";
import VueHorizontal from "vue-horizontal";
import axios from "axios";
import VueMeta from "vue-meta";
import vClickOutside from "v-click-outside";
import "./assets/tailwind.css";

axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}/api/`;

Vue.config.productionTip = false;
Vue.use(VueCarousel);
Vue.use(VueCookies);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});
Vue.use(vClickOutside);

// Vue.use(VueDragscroll);
Vue.use(VueHorizontal);
// Vue.directive("observe-visibility", ObserveVisibility);
Vue.directive("animate-in", el => {
  el.classList.add("invisible");
  let observer = new IntersectionObserver(
    (entries, observer) => {
      // console.log('check:', entries)
      if (entries[0].isIntersecting) {
        // console.log('intersect: ', entries[0], el)
        el.classList.add("visible");
        el.classList.remove("invisible");
        observer.disconnect();
      }
    },
    {
      rootMargin: "-20%",
      treshold: 10
    }
  );
  observer.observe(el);
});

new Vue({
  router,
  store,
  /* beforeCreate() {
		this.$store.commit('initialiseStore');
	}, */
  watch: {
    "$store.state.answers"() {
      // console.log("store change: ", this.$store.state.answers);
    }
  },
  render: h => h(App)
}).$mount("#app");
